import getIn from 'immutable-less/transmute/getIn';
export const getEventAnchorFromContextMap = ({
  contextMap
}) => {
  return {
    errors: [],
    contactPropertyAnchor: getIn(['CLASSIC_ANCHORED_DELAY_CONTACT_PROPERTY_ANCHOR'], contextMap) || null,
    staticDateAnchor: getIn(['CLASSIC_ANCHORED_DELAY_STATIC_DATE_ANCHOR'], contextMap) || null
  };
};